import { Typography } from 'antd';
import { Loadable, PageHeader, TabButtons, TabItem } from 'components';
import { useTitle } from 'hooks';
import { permissionsMessages, rolesMessages, sidebarMenuMessages, vipCustomersMessages } from 'messages';
import { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ROUTE } from 'routes/constants';

function VipCustomerLayout() {
  useTitle(sidebarMenuMessages.vipCustomer);
  const location = useLocation();
  const navigate = useNavigate();

  const tabItems: TabItem[] = [
    {
      key: ROUTE.VIP_CUSTOMERS,
      label: vipCustomersMessages.vipCustomer
    },
    {
      key: ROUTE.VIP_CUSTOMERS_GROUP,
      label: vipCustomersMessages.vipCustomerGroup
    }
  ];

  const handleClickTab = (tabKey: string) => {
    navigate(tabKey);
  };

  return (
    <div>
      <div className='h-full rounded-xl bg-colorBgContainer'>
        <TabButtons
          className='min-h-[88px] items-center p-6'
          items={tabItems}
          onClick={(tabKey) => handleClickTab(tabKey as string)}
          activeKey={location.pathname}
        />
        <div className='max-h-[calc(100%-56px)]'>
          <Loadable>
            <Outlet />
          </Loadable>
        </div>
      </div>
    </div>
  );
}

export default VipCustomerLayout;
